module.exports = __webpack_public_path__ + "static/media/ancestry_main@2x.c4b544b2.png";